// TODO!: Implement 404 page once design is available
export const NoMatch = () => (
  <div>
    <h1>404 Not Found</h1>
  </div>
);
